import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Lock, Envelope } from '@phosphor-icons/react';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    setLoading(false);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="auth-container px-4">
      <div className="w-full max-w-md p-6 sm:p-8 border border-border bg-card rounded-sm">
        <div className="mb-8">
          <h1 className="text-4xl tracking-tight font-bold mb-2">Welcome Back</h1>
          <p className="text-muted-foreground text-sm">SIGN IN TO YOUR BUSINESS DASHBOARD</p>
        </div>

        {error && (
          <div
            data-testid="login-error"
            className="mb-6 p-4 bg-destructive/10 border border-destructive text-destructive text-sm rounded-sm"
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="email" className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground">
              Email Address
            </Label>
            <div className="relative">
              <Envelope className="absolute left-3 top-1/2 -translate-y-1/2" size={18} weight="regular" />
              <Input
                id="email"
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="pl-10 h-12 rounded-sm"
                required
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="password" className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground">
              Password
            </Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2" size={18} weight="regular" />
              <Input
                id="password"
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pl-10 h-12 rounded-sm"
                required
              />
            </div>
          </div>

          <Button
            data-testid="login-submit-button"
            type="submit"
            className="w-full h-12 rounded-sm font-semibold tracking-tight"
            disabled={loading}
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </Button>
        </form>

        <div className="mt-6 text-center text-sm">
          <span className="text-muted-foreground">Don't have an account? </span>
          <Link
            to="/register"
            data-testid="navigate-to-register"
            className="text-accent hover:text-accent/90 font-medium"
          >
            Create Account
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
